<router-outlet></router-outlet>
<p-toast position="top-right"></p-toast>